/** @type {Record<string, Record<string, string>>} */
export const assignmentUi = {
  newTasksTitle: {
    en: 'You have {count} new tasks assigned to you',
    ru: 'Вам назначено новых задач: {count}',
    es: 'Tienes {count} tareas nuevas asignadas',
    fr: 'Vous avez {count} nouvelles tâches assignées',
    zh: '你有 {count} 项新任务',
    hi: 'आपको {count} नए कार्य असाइन किए गए हैं',
  },
  newAssignmentsTitle: {
    en: 'You have {count} new assignments',
    ru: 'У вас новых назначений: {count}',
    es: 'Tienes {count} asignaciones nuevas',
    fr: 'Vous avez {count} nouvelles affectations',
    zh: '你有 {count} 项新分配',
    hi: 'आपके पास {count} नए असाइनमेंट हैं',
  },
  assignedBy: {
    en: 'Assigned by {name}',
    ru: 'Назначил(а) {name}',
    es: 'Asignada por {name}',
    fr: 'Assignée par {name}',
    zh: '由 {name} 分配',
    hi: '{name} ने असाइन किया',
  },
  role: {
    en: 'Role: {role}',
    ru: 'Роль: {role}',
    es: 'Rol: {role}',
    fr: 'Rôle : {role}',
    zh: '角色：{role}',
    hi: 'भूमिका: {role}',
  },
  overdueSummary: {
    en: '{count} overdue',
    ru: 'Просрочено: {count}',
    es: '{count} vencidas',
    fr: '{count} en retard',
    zh: '{count} 项已逾期',
    hi: '{count} अतिदेय',
  },
  viewMyTasks: {
    en: 'View My Tasks',
    ru: 'Открыть мои задачи',
    es: 'Ver mis tareas',
    fr: 'Voir mes tâches',
    zh: '查看我的任务',
    hi: 'मेरे कार्य देखें',
  },
  acknowledgeContinue: {
    en: 'Acknowledge & Continue',
    ru: 'Подтвердить и продолжить',
    es: 'Confirmar y continuar',
    fr: 'Confirmer et continuer',
    zh: '确认并继续',
    hi: 'स्वीकार करें और जारी रखें',
  },
  myWork: {
    en: 'My Work',
    ru: 'Моя работа',
    es: 'Mi trabajo',
    fr: 'Mon travail',
    zh: '我的工作',
    hi: 'मेरा काम',
  },
  overdue: {
    en: 'Overdue',
    ru: 'Просрочено',
    es: 'Vencido',
    fr: 'En retard',
    zh: '已逾期',
    hi: 'अतिदेय',
  },
  dueToday: {
    en: 'Due Today',
    ru: 'На сегодня',
    es: 'Para hoy',
    fr: 'Pour aujourd’hui',
    zh: '今天到期',
    hi: 'आज देय',
  },
  thisWeek: {
    en: 'This Week',
    ru: 'На этой неделе',
    es: 'Esta semana',
    fr: 'Cette semaine',
    zh: '本周',
    hi: 'इस सप्ताह',
  },
  waiting: {
    en: 'Waiting',
    ru: 'Ожидание',
    es: 'En espera',
    fr: 'En attente',
    zh: '等待中',
    hi: 'प्रतीक्षा',
  },
  waitingOnYou: {
    en: 'Waiting on you',
    ru: 'Ждут вас',
    es: 'Esperan por ti',
    fr: 'En attente de vous',
    zh: '正在等你',
    hi: 'आपकी प्रतीक्षा',
  },
  view: {
    en: 'View',
    ru: 'Открыть',
    es: 'Ver',
    fr: 'Voir',
    zh: '查看',
    hi: 'देखें',
  },
  viewAll: {
    en: 'View All My Tasks',
    ru: 'Все мои задачи',
    es: 'Ver todas mis tareas',
    fr: 'Voir toutes mes tâches',
    zh: '查看我的全部任务',
    hi: 'मेरे सभी कार्य देखें',
  },
  myWorkClear: {
    en: 'Nothing assigned right now.',
    ru: 'Сейчас ничего не назначено.',
    es: 'Nada asignado por ahora.',
    fr: 'Rien d’assigné pour le moment.',
    zh: '目前没有分配给你的任务。',
    hi: 'अभी कुछ असाइन नहीं है।',
  },
  projectTeam: {
    en: 'Project team',
    ru: 'Команда проекта',
    es: 'Equipo del proyecto',
    fr: 'Équipe du projet',
    zh: '项目团队',
    hi: 'प्रोजेक्ट टीम',
  },
  dueDateWarning: {
    en: 'A due date helps this show up in My Work. You can still save without one.',
    ru: 'Срок помогает задаче появиться в «Моей работе». Сохранить можно и без него.',
    es: 'Una fecha de entrega ayuda a verla en Mi trabajo. Puedes guardar sin ella.',
    fr: 'Une échéance aide à la voir dans Mon travail. Vous pouvez enregistrer sans.',
    zh: '填写截止日期后，任务会出现在「我的工作」里。也可以先不填。',
    hi: 'देय तिथि इसे मेरे काम में दिखाती है। बिना इसके भी सहेज सकते हैं।',
  },
  assigneeRequired: {
    en: 'Assign this task to someone.',
    ru: 'Назначьте задачу сотруднику.',
    es: 'Asigna esta tarea a alguien.',
    fr: 'Assignez cette tâche à quelqu’un.',
    zh: '请把任务分配给某人。',
    hi: 'इस कार्य को किसी को असाइन करें।',
  },
  noProject: {
    en: 'No project',
    ru: 'Без проекта',
    es: 'Sin proyecto',
    fr: 'Sans projet',
    zh: '无项目',
    hi: 'कोई प्रोजेक्ट नहीं',
  },
};

export function fillCount(template, count) {
  return String(template || '').replace('{count}', String(count));
}
